// animation
import { Fade } from "react-awesome-reveal";

const StepFour = ({
  formData,
  setFormData,
  setActiveStep,
  frequencyList
}) => {

  return (
    <>
      <div className="step_card_body justify_content_start">
        <Fade triggerOnce delay={400} duration={1200}>
          <h3>Cool! We know you're<br/>busy, so check this out:</h3>
        </Fade>
        <br />
        <Fade triggerOnce delay={1100} duration={1500}>
          <p>
            You DO NOT have to use MamaZen every day to get results. Just
            listening once or twice a week will do the trick!
            <br />
            <br />
            About how many times per week would you like to use MamaZen?
          </p>
        </Fade>
        <br />
        <Fade triggerOnce cascade delay={1300}>
          {frequencyList?.map((item, index) => (
            <Fade triggerOnce damping={0.8} delay={300} key={index}>
              <div
                role="button"
                className={`frequency_box ${
                  formData?.frequency === item?.name ? " selected" : ""
                }`}
                onClick={() => {
                  setFormData({ ...formData, frequency: item?.name });
                  setActiveStep(4)
                }}
              >
                <p>{item?.title}</p>
              </div>
            </Fade>
          ))}
        </Fade>
      </div>
      <br />

      {/* <div className="mt_auto">
        <Fade triggerOnce delay={1400} duration={1300}>
          <button
            disabled={!formData?.frequency?.length > 0}
            onClick={() => setActiveStep(4)}
            className="cs_btn w_100"
          >
            Continue
          </button>
        </Fade>
      </div> */}
    </>
  );
};

export default StepFour;
